import { ApiModel } from 'types/swagger/clarifai-api';

export const getModelUniqueId = (model?: ApiModel) => {
  return `${model?.user_id}/${model?.app_id}/${model?.id}`;
};
